import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Button,
  PageTitle,
  FormFieldSet,
  useFormHandler,
  PageHeader,
  showToast,
} from "../../../components";

import {
  EmploymentType,
  EmployeeClassification,
} from "../../../assets/data/enumData";
import { Gender } from "../../../assets/data/enumData";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  saveDraft,
  addNewEmployeeStart,
} from "../../../redux/slices/employee/employeeSlice";

import { fetchLatestUiid } from "../../../redux/slices/employee/employeeApi"; // Assume this is your API service
import { useLoginUser } from "../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../utils/filterEmptyValues";
import useDropdownData from "../../../hooks/useDropdownData";
import { AddEmployeeJobRoleOptions } from "../../../assets/data/projectData";
import common from "../../../utils/common";
// Move these outside the component

const AddEmployee = () => {
  const { convertEntryption, validatePhoneNumber } = common;
  const [latestUiid, setLatestUiid] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { userData: loginUserData } = useLoginUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { draft, lastSaved } = useSelector((state) => state.employee);
  const containerRef = useRef(null);
  // Add state for UIID
  const loginUserUiid = loginUserData?.uiid;
  const organizationId = loginUserData?.organizationId.uiid;

  // useEffect(() => {
  //   const fetchLatestUiidData = async () => {
  //     try {
  //       const response = await fetchLatestUiid("employees");
  //       //console.log("Latest UIID Data:", response); // For debugging
  //       setLatestUiid(response.data.data.count + 1); // Modified this line
  //     } catch (error) {
  //       // console.error("Error fetching latest UIID:", error);
  //       showToast("Error fetching latest UIID", "error", 5000);
  //     }
  //   };

  //   fetchLatestUiidData();
  // }, []);
  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("employees");
        const count = response?.data?.data?.count;

        if (typeof count === "number") {
          setLatestUiid(count + 1);
        } else {
          setLatestUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        setLatestUiid(1);
      }
    };

    fetchLatestUiidData();
  }, []);
  const defaultValue = {
    firstName: location.state?.incomingData?.firstName || "",
    middleName: location.state?.incomingData?.middleName || "",
    lastName: location.state?.incomingData?.lastName || "",
    jobTitle: location.state?.incomingData?.jobTitle ? { label: location.state.incomingData.jobTitle, value: location.state.incomingData.jobTitle } : "",
    jobTitleNew: "",
    emailAddress: location.state?.incomingData?.emailAddress || "",
    alternateEmailAddress: location.state?.incomingData?.alternateEmailAddress || "",
    dateOfBirth: location.state?.incomingData?.dateOfBirth || "",
    socialSecurityNumber: "",
    contactNumber: location.state?.incomingData?.contactNumber || undefined,
    countryCode: location.state?.incomingData?.countryCode || "+1",
    gender: location.state?.incomingData?.gender || undefined,
    employmentType: location.state?.incomingData?.employmentType || undefined,
    linkedTo: "",
    //employeeId: latestUiid,
    dateOfJoining: location.state?.incomingData?.dateOfJoining || "",
    financeManager: undefined,
    hrManager: undefined,
    immigrationManager: undefined,
    fullAddress: location.state?.incomingData?.fullAddress || "",
    countryList: location.state?.incomingData?.countryList || "",
    // cityStateList: "",
    city: location.state?.incomingData?.city || "",
    state: location.state?.incomingData?.state || "",
    zipCode: location.state?.incomingData?.zipCode || undefined,
    classification: location.state?.incomingData?.classification || 1,
    createUserAccount: [],
    jobRole: "",
    userPassword: "",
  };
  const [checkValids, setCheckValids] = useState({});
  // Memoize form handler
  const {
    formData,
    errors,
    handleChange,
    validateAllFields,
    setFormData,
    setErrors,
  } = useFormHandler(defaultValue, checkValids);
  // setErrors(...errors,contactNumber:)
  useEffect(() => {
    if (formData?.classification === 1) {
      setErrors({
        firstName: "",
        middleName: "",
        lastName: "",
        jobTitle: "",
        jobTitleNew: "",
        emailAddress: "",
        alternateEmailAddress: "",
        dateOfBirth: "",
        socialSecurityNumber: "",
        contactNumber: "",
        gender: "",
        employmentType: "",
        //employeeId: latestUiid,
        dateOfJoining: "",
        financeManager: "",
        hrManager: "",
        immigrationManager: "",
        fullAddress: "",
        countryList: "",
        // cityStateList: "",
        city: "",
        state: "",
        zipCode: "",
        // classification: 1,
        // createUserAccount: [],
        // jobRole: "",
        // userPassword: "",
      });
      setCheckValids({
        firstName: { type: "text", required: true },
        lastName: { type: "text", required: true },
        // jobTitleNew: { type: "select", required: true },
        jobTitle: { type: "select", required: true },
        emailAddress: { type: "email", required: true },
        // dateOfBirth: { type: "date" },
        contactNumber: { type: "phone", required: true },
        employmentType: { type: "select", required: true },
        dateOfJoining: {
          type: "date",
          required: true,
        },
        // financeManager: { type: "select", required: true },
        // hrManager: { type: "select", required: true },
        // immigrationManager: { type: "select", required: true },
        countryList: { type: "select", required: true },
        // cityStateList: { type: "select", required: true },
        city: { type: "select", required: true },
        state: { type: "select", required: true },
        classification: { type: "radio", required: true },
        alternateEmailAddress: { type: "email" },
      });
    } else {
      setErrors({
        firstName: "",
        middleName: "",
        lastName: "",
        jobTitle: "",
        jobTitleNew: "",
        emailAddress: "",
        alternateEmailAddress: "",
        dateOfBirth: "",
        socialSecurityNumber: "",
        contactNumber: "",
        gender: "",
        employmentType: "",
        //employeeId: latestUiid,
        dateOfJoining: "",
        financeManager: "",
        hrManager: "",
        immigrationManager: "",
        fullAddress: "",
        countryList: "",
        // cityStateList: "",
        city: "",
        state: "",
        zipCode: "",
        // classification: 1,
        // createUserAccount: [],
        jobRole: "",
        userPassword: "",
      });
      setCheckValids({
        firstName: { type: "text", required: true },
        lastName: { type: "text", required: true },
        // jobTitleNew: { type: "select", required: true },
        jobTitle: { type: "select", required: true },
        emailAddress: { type: "email", required: true },
        // dateOfBirth: { type: "date" },
        contactNumber: { type: "mobileNew", required: true },
        employmentType: { type: "select", required: true },
        dateOfJoining: {
          type: "date",
          required: true,
          notMatchField: "dateOfBirth",
        },
        // financeManager: { type: "select", required: true },
        // hrManager: { type: "select", required: true },
        // immigrationManager: { type: "select", required: true },

        classification: { type: "radio", required: true },
        alternateEmailAddress: { type: "email", notMatchField: "emailAddress" },
      });
    }
  }, [formData?.classification]);
  const handleSubmit = () => {
    const isValid = validateAllFields();
    //console.log(typeof formData.contactNumber);

    if (isValid) {
      // const [city, state] = formData.cityStateList?.value
      //   ? formData.cityStateList?.value.split("-")
      //   : ["", ""];
      const submissionData = {
        addedBy: loginUserUiid,
        organizationId: organizationId,
        incomingPlacementId: location?.state?.incomingData?.incomingPlacementId,
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        gender: formData.gender,
        mobile: {
          primary: {
            code: formData.countryCode,
            number: formData.contactNumber,
          },
        },
        email: {
          primary: formData.emailAddress,
          secondary: formData.alternateEmailAddress,
        },
        location: {
          address1: formData.fullAddress,
          city: formData.city.value,
          state: formData.state.value,
          zipCode: formData.zipCode,
          country: formData.countryList?.value,
        },
        employmentType: formData.employmentType,
        linkedTo: formData?.linkedTo?.value ?? formData?.linkedTo,
        joinDate: formData.dateOfJoining,
        jobTitle: formData.jobTitle?.value ?? formData.jobTitle ?? "",
        classification: formData.classification,
        dob: formData.dateOfBirth,
        managers: {
          finance: formData.financeManager?.value,
          HR: formData.hrManager?.value,
          immigration: formData.immigrationManager?.value,
        },
        ssn: formData.socialSecurityNumber,
        addToUser:
          formData?.classification === 2
            ? true
            : formData.createUserAccount?.length > 0,
        jobRole: formData?.jobRole?.value ?? formData?.jobRole,
        password:
          formData?.classification === 2
            ? formData?.userPassword
              ? convertEntryption(formData?.userPassword)
              : ""
            : "",
      };
      //console.log("submissionData page", submissionData);

      // Filter out empty values before dispatching
      const filteredData = filterEmptyValues(submissionData);
      //console.log("filteredData page", filteredData);

      //console.log(payload,url);
      dispatch(addNewEmployeeStart({ submissionData: filteredData, navigate }));
      //dispatch(addNewEmployeeStart(submissionData));

      //console.log("Form submitted successfully:", body);
    } else {
      //console.log("Please fix the errors before submitting.");
      showToast("All mandatory fields must be filled out.", "error", 5000);
    }
  };

  // Optimize handleSave with useCallback
  const handleSave = useCallback(() => {
    dispatch(saveDraft(formData));
    showToast("Draft saved successfully", "info", 5000);
  }, [formData, dispatch]);
  // Load draft on component mount (incomingData is already applied via defaultValue)
  useEffect(() => {
    if (location.state?.incomingData) {
      // incomingData fields are already mapped to the correct format in defaultValue initialization.
      // Only apply fields here that need explicit re-setting after mount (e.g., async-dependent fields).
      // Do NOT spread raw incomingData — it would overwrite structured fields like jobTitle {label, value} with flat strings.
    } else if (draft) {
      setFormData(draft);
    }
  }, [draft, location.state]);

  const [fmManagerSearch, setFmManagerSearch] = useState("");
  const handleFmManagerSearch = (value) => {
    setFmManagerSearch(value);
  };

  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////
  // const {
  //   data: jobTitleOptions,
  //   searchValue: jobTitlesSearch,
  //   handleSearch: handleJobTitlesSearch,
  //   resetSearch: resetJobTitlesSearch,
  //   handleScroll: handleJobTitlesScroll,
  // } = useDropdownData("jobTitles");

  // const {
  //   data: fmOptions,
  //   searchValue: financeManagerSearch,
  //   handleSearch: handleFinanceManagerSearch,
  //   resetSearch: resetFinanceManagerSearch,
  //   handleScroll: handleFinanceManagerScroll,
  // } = useDropdownData("financeManager", 5, {}, { orgId: organizationId });

  // const {
  //   data: hmOptions,
  //   searchValue: hiringManagerSearch,
  //   handleSearch: handleHiringManagerSearch,
  //   resetSearch: resetHiringManagerSearch,
  //   handleScroll: handleHiringManagerScroll,
  // } = useDropdownData("hiringManager", 5, {}, { orgId: organizationId });

  // const {
  //   data: immigrationOptions,
  //   searchValue: immigrationManagerSearch,
  //   handleSearch: handleImmigrationManagerSearch,
  //   resetSearch: resetImmigrationManagerSearch,
  //   handleScroll: handleImmigrationManagerScroll,
  // } = useDropdownData("immigrationManager", 5, {}, { orgId: organizationId });

  const { data: countryOptions, handleScroll: handleCountriesScroll } =
    useDropdownData("countriesUsAndCanada");

  // For city-state, we need to depend on the selected country
  const countryId = countryOptions.find(
    (item) => item.label === formData.countryList?.label
  )?.id;
  console.log("formData.countryList", formData.countryList);
  console.log(
    "omkar list check",
    countryOptions,
    formData.countryList,
    countryId
  );

  // const {
  //   data: cityStateOptions,
  //   searchValue: citiesStateSearch,
  //   handleSearch: handleCitiesStateSearch,
  //   resetSearch: resetCitiesStateSearch,
  //   handleScroll: handleCitiesStateScroll,
  // } = useDropdownData(
  //   "citiesState",
  //   10,
  //   { countryList: formData.countryList }, // This dependency will trigger a refetch when country changes
  //   { countrySearch: countryId }
  // );

  // const [fmOptions, setFmOptions] = useState([]);
  // const [hmOptions, setHmOptions] = useState([]);
  // const [immigrationOptions, setImmigrationOptions] = useState([]);
  // const [jobTitleOptions, setJobTitleOptions] = useState([]);
  // const [countryOptions, setCountryOptions] = useState([]);
  // const [cityStateOptions, setCityStateOptions] = useState([]);

  // //
  // const [loading, setLoading] = useState(false);
  // const containerRef = useRef(null);
  // //

  // const [allDropDownSearch, setAllDropDownSearch] = useState({
  //   financeManager: "",
  //   hiringManager: "",
  //   immigrationManager: "",
  //   jobTitles: "",
  //   countries: "",
  //   citiesState: "",
  // });
  // const handleAllDropDownSearch = (key, value) => {
  //   console.log("key", key, "value", value);
  //   setAllDropDownSearch((prevState) => ({
  //     ...prevState,
  //     [key]: value,
  //   }));
  // };
  // const resetDropdownSearch = (key) => {
  //   // setAllDropDownSearch((prevState) => ({
  //   //   ...prevState,
  //   //   [key]: "",
  //   // }));
  // };
  // const [limit, setLimit] = useState({
  //   financeManager: 5,
  //   hiringManager: 5,
  //   immigrationManager: 5,
  //   jobTitles: 5,
  //   countries: 5,
  //   citiesState: 10,
  // });

  // ///////////////
  // useEffect(() => {
  //   const fetchjobData = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await dropDownGetter(
  //         "jobTitles",
  //         limit.jobTitles,
  //         allDropDownSearch.jobTitles
  //       );
  //       setJobTitleOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching jobTitles data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchjobData();
  // }, [limit.jobTitles, allDropDownSearch.jobTitles]);

  // useEffect(() => {
  //   const fetchFmData = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await dropDownGetter(
  //         "financeManager",
  //         limit.financeManager,
  //         allDropDownSearch.financeManager,
  //         {
  //           orgId: organizationId,
  //         }
  //       );
  //       setFmOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching financeManager data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchFmData();
  // }, [limit.financeManager, allDropDownSearch.financeManager]);

  // useEffect(() => {
  //   const fetchHmData = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await dropDownGetter(
  //         "hiringManager",
  //         limit.hiringManager,
  //         allDropDownSearch.hiringManager,
  //         { orgId: organizationId }
  //       );
  //       setHmOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching hiringManager data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchHmData();
  // }, [limit.hiringManager, allDropDownSearch.hiringManager]);

  // useEffect(() => {
  //   const fetchImmigrationData = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await dropDownGetter(
  //         "immigrationManager",
  //         limit.immigrationManager,
  //         allDropDownSearch.immigrationManager,
  //         { orgId: organizationId }
  //       );
  //       setImmigrationOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching immigrationManager data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchImmigrationData();
  // }, [limit.immigrationManager, allDropDownSearch.immigrationManager]);

  // useEffect(() => {
  //   const fetchCountriesData = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await dropDownGetter("countries", limit.countries);
  //       setCountryOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching countries data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchCountriesData();
  // }, [limit.countries]);

  // useEffect(() => {
  //   const fetchCitiesStateData = async () => {
  //     try {
  //       const countryId = countryOptions.find(
  //         (item) => item.label === formData.countryList
  //       )?.id;
  //       console.log("country id", countryId);
  //       setLoading(true);
  //       const data = await dropDownGetter(
  //         "citiesState",
  //         limit.citiesState,
  //         allDropDownSearch.citiesState,
  //         { countrySearch: countryId }
  //       );
  //       setCityStateOptions(data || []);
  //     } catch (error) {
  //       console.error("Error fetching citiesState data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   console.log("formData.country", formData.countryList);
  //   if (formData.countryList) {
  //     console.log("formData.country", formData.countryList);
  //     fetchCitiesStateData();
  //   }
  // }, [limit.citiesState, allDropDownSearch.citiesState, formData.countryList]);

  // const handleScroll = (type) => {
  //   const container = containerRef.current;
  //   if (!container) return;

  //   const nearBottom =
  //     container.scrollTop + container.clientHeight >=
  //     container.scrollHeight - 10;

  //   if (nearBottom && !loading) {
  //     setLimit((prev) => ({
  //       ...prev,
  //       [type]: prev[type] + 5,
  //     }));
  //   }
  // };

  ///////////////////////////////////////////////////
  ///// Get select data form server end
  ///////////////////////////////////////////////////

  /////
  const handleChangeClassification = (value) => {
    setFormData((prev) => ({ ...prev, classification: value }));
  };
  return (
    <div className="flex flex-col overflow-auto border-[1px] border-neutrals-50 rounded w-full h-full px-8 py-3">
      {fmManagerSearch}
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Employee Details"} icon={"badge"} tag="h5" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Back"
                size="sm"
                icon={"arrow_left_alt"}
                onClick={() => window.history.back()}
              />
            </>
          }
        />
      </div>
      <div>
        <div className=" xs:col-span-1 md:col-span-2 lg:col-span-3 ">
          <div className="flex">
            <PageHeader
              Section={<PageTitle title={"Classification"} tag="h6" />}
            />
          </div>
          <FormFieldSet
            type="radio"
            title={""}
            noTitle
            options={EmployeeClassification}
            value={formData.classification}
            onChange={(event) =>
              handleChangeClassification(Number(event.target.value))
            }
            error={errors.classification}
          />
        </div>
        {formData.classification === 1 && (
          <div className=" xs:col-span-1 md:col-span-2 lg:col-span-3 ">
            <FormFieldSet
              type="checkbox"
              size={"md"}
              title={""}
              noTitle
              options={[
                {
                  label: "Create a User Account for this Employee",
                  value: true,
                },
              ]}
              values={formData.createUserAccount || []}
              onChange={(value) => handleChange("createUserAccount", value)}
              multiple
              error={errors.createUserAccount}
            />
          </div>
        )}

        <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 mt-2">
          <FormFieldSet
            type="text"
            title={"First Name"}
            placeholder="Enter First Name"
            value={formData.firstName}
            onChange={(value) => handleChange("firstName", value)}
            error={errors.firstName}
            required
          />
          <FormFieldSet
            type="text"
            title={"Middle Name"}
            placeholder="Enter Middle Name"
            value={formData.middleName}
            onChange={(value) => handleChange("middleName", value, {})}
            error={errors.middleName}
          />
          <FormFieldSet
            type="text"
            title={"Last Name"}
            placeholder="Enter Last Name"
            value={formData.lastName}
            onChange={(value) => handleChange("lastName", value)}
            error={errors.lastName}
            required
          />

          <FormFieldSet
            type="jobTitle"
            title={"Job Title"}
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showSearch
            showButton
            required
          />

          <FormFieldSet
            type="text"
            title={"Email Address"}
            placeholder="Enter Email Address"
            value={formData.emailAddress}
            onChange={(value) => handleChange("emailAddress", value)}
            error={errors.emailAddress}
            required
          />
          <FormFieldSet
            type="text"
            title={"Alternate Email Address"}
            placeholder="Enter Alternate Email Address"
            value={formData.alternateEmailAddress}
            onChange={(value) => handleChange("alternateEmailAddress", value)}
            error={errors.alternateEmailAddress}
          />

          <FormFieldSet
            type="datepicker"
            title={"Date of Birth"}
            placeholder="Select Date of Birth"
            maxDate={new Date()}
            value={formData.dateOfBirth}
            onChange={(value) => handleChange("dateOfBirth", value)}
            error={errors.dateOfBirth}
            showDropdown={false}
          />

          <FormFieldSet
            type="phone"
            title={"Contact Number"}
            placeholder="Enter Contact Number"
            value={formData.contactNumber?.toString() || ""}
            onChange={(fullValue, details) => {
              handleChange("contactNumber", details.number.toString());
              handleChange("countryCode", details.countryCode);
              setErrors({
                ...errors,
                contactNumber: details.number
                  ? details?.error?.valid === true
                    ? ""
                    : "Mobile number invalid"
                  : "",
              });
            }}
            error={errors.contactNumber}
            required
          />

          <FormFieldSet
            type="select"
            title={"Gender"}
            placeholder="Select Gender"
            options={Gender}
            value={formData.gender}
            onChange={(value) => handleChange("gender", value)}
            error={errors.gender}
          />

          <FormFieldSet
            type="select"
            title={"Employment Type"}
            placeholder="Select Employment Type"
            value={formData.employmentType}
            onChange={(value) => handleChange("employmentType", value)}
            options={EmploymentType}
            error={errors.employmentType}
            required
          />
          {formData.employmentType === 4 && (
            <FormFieldSet
              type="employeesSorted"
              title={"Link To"}
              placeholder="Select Link To"
              value={formData.linkedTo}
              showSearch
              onChange={(value) => handleChange("linkedTo", value)}
              error={errors.linkedTo}
              required={formData.employmentType === 4 ? true : false}
            />
          )}  
          
          <FormFieldSet
            type="text"
            title={"Employee ID"}
            placeholder="Enter Employee ID"
            value={latestUiid}
            error={errors.employeeId}
            disabled
          />

          <FormFieldSet
            type="datepicker"
            title={"Date of Joining"}
            placeholder="Select Date of Joining"
            value={formData.dateOfJoining}
            onChange={(value) => handleChange("dateOfJoining", value)}
            // minDate
            maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
            error={errors.dateOfJoining}
            required
            showDropdown={false}
          />

          {formData.classification === 2 && (
            <>
              <FormFieldSet
                type="select"
                title={"Job Role"}
                placeholder="Select Job Role"
                value={formData.jobRole}
                onChange={(value) => handleChange("jobRole", value)}
                error={errors.jobRole}
                options={AddEmployeeJobRoleOptions}
                showButton
                showSearch
              />
              {console.log(formData)}
              <FormFieldSet
                type="password"
                title={"password"}
                placeholder="Enter Password"
                value={formData.userPassword}
                onChange={(e) => handleChange("userPassword", e.target.value)}
                // passwordFotmat={{
                //   base: "ram",
                // }}
              />
            </>
          )}

          {formData.classification === 1 && (
            <>
              <FormFieldSet
                type="financeManager"
                title={"Finance Manager"}
                placeholder="Select Job Title"
                value={formData.financeManager}
                onChange={(value) => {
                  handleChange("financeManager", value);
                }}
                error={errors.financeManager}
                showSearch
                // required
              />

              <FormFieldSet
                type="hrManager"
                title={"HR Manager"}
                placeholder="Select HR Manager"
                value={formData.hrManager}
                onChange={(value) => handleChange("hrManager", value)}
                error={errors.hrManager}
                showSearch
                // required
              />
              <FormFieldSet
                type="immigrationManager"
                title={"Immigration Manager"}
                placeholder="Select Immigration Manager"
                value={formData.immigrationManager}
                onChange={(value) => handleChange("immigrationManager", value)}
                error={errors.immigrationManager}
                showSearch
                // required
              />

              <div className=" xs:col-span-1 md:col-span-2 lg:col-span-3 ">
                <div className="mb-3 flex">
                  <PageHeader
                    Section={<PageTitle title={"Location"} tag="h6" />}
                  />
                </div>

                <FormFieldSet
                  type="text"
                  title={"Full Address"}
                  placeholder="Enter Full Address"
                  value={formData.fullAddress}
                  onChange={(value) => handleChange("fullAddress", value)}
                  error={errors.fullAddress}
                />
              </div>

              <FormFieldSet
                type="countriesUsAndCanada"
                title={"Country"}
                placeholder="Select Country"
                value={formData.countryList}
                onChange={(value) => handleChange("countryList", value)}
                error={errors.countryList}
                required
              />

              {/* <FormFieldSet
            type="citiesState"
            title={"City/State"}
            placeholder="Select City/State"
            value={formData.cityStateList}
            onChange={(value) => handleChange("cityStateList", value)}
            error={errors.cityStateList}
            required
            parentValue={{ country: formData.countryList.value }}
            parentId={countryId}
            disabled={!formData.countryList}
          /> */}
              {console.log("formdata", formData)}
              <FormFieldSet
                showSearch
                type="states"
                title={"State"}
                keyname={"states"}
                placeholder="Select State"
                value={formData.state}
                onChange={(value) => handleChange("state", value)}
                error={errors.state}
                required
                parentValue={{ country: formData.countryList.value }}
                // parentId={countryId}
                disabled={!formData.countryList}
              />
              <FormFieldSet
                type="cities"
                showSearch
                keyname={"cities"}
                title={"City"}
                placeholder="Select City"
                value={formData.city}
                onChange={(value) => handleChange("city", value)}
                error={errors.city}
                required
                parentValue={{
                  country: formData.countryList.value,
                  state: formData.state.value,
                }}
                // parentId={countryId}
                disabled={!formData.state}
              />

              {/* <FormFieldSet
            type="select"
            title={"Country"}
            keyname={"countries"}
            placeholder="Select Country"
            value={formData.countryList}
            onChange={(value) => handleChange("countryList", value)}
            options={countryOptions}
            error={errors.countryList}
            refData={containerRef}
            handleScroll={() => handleCountriesScroll(containerRef)}
            required
          /> */}

              {/* <FormFieldSet
            type="select"
            title={"City/State"}
            keyname={"citiesState"}
            placeholder="Select City/State"
            value={formData.cityStateList}
            onChange={(value) => handleChange("cityStateList", value)}
            options={cityStateOptions}
            showSearch
            searchValue={citiesStateSearch}
            onSearch={handleCitiesStateSearch}
            onClose={resetCitiesStateSearch}
            error={errors.cityStateList}
            disabled={!formData.countryList}
            refData={containerRef}
            handleScroll={() => handleCitiesStateScroll(containerRef)}
            required
          /> */}

              <FormFieldSet
                type="text"
                title={"Zip Code"}
                placeholder="Enter Zip Code"
                value={formData.zipCode?.toString() || ""}
                onChange={(value) => handleChange("zipCode", Number(value))}
                error={errors.zipCode}
              />

              {/* <div className=" xs:col-span-1 md:col-span-2 lg:col-span-3 ">
            <div className="flex mb-3">
              <PageHeader
                Section={<PageTitle title={"Classification"} tag="h6" />}
              />
            </div>
            <FormFieldSet
              type="radio"
              title={""}
              options={EmployeeClassification}
              value={formData.classification}
              onChange={
                (event) =>
                  handleChange("classification", Number(event.target.value)) // Convert back to number
              }
              error={errors.classification}
            />
          </div> */}

              {/* <div className=" xs:col-span-1 md:col-span-2 lg:col-span-3 ">
            <FormFieldSet
              type="checkbox"
              size={"md"}
              title={""}
              options={[
                {
                  label: "Create a User Account for this Employee",
                  value: true,
                },
              ]}
              values={formData.createUserAccount || []}
              onChange={(value) => handleChange("createUserAccount", value)}
              multiple
              error={errors.createUserAccount}
            />
          </div> */}
            </>
          )}
        </div>
        <div className="flex justify-end items-center gap-4 mt-5">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => window.history.back()}
            disabled={isLoading}
          />
          <Button
            variant="outlined"
            title={"Save to draft"}
            onClick={handleSave}
            disabled={isLoading}
          />
          <Button
            title={"Submit"}
            onClick={handleSubmit}
            disabled={isLoading}
            //loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
